import { render } from "./SmDisasterIcon.vue?vue&type=template&id=22b9f15c&scoped=true"
const script = {}

import "./SmDisasterIcon.vue?vue&type=style&index=0&id=22b9f15c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b9f15c"]])

export default __exports__